var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"min-height":_vm.height}},[_c('v-container',[_c('v-row',{attrs:{"justify":"space-around","align":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('ProductsChart',{attrs:{"clients":_vm.clients}})],1),_c('v-col',{attrs:{"cols":"12","md":"8"}},[_c('LineClientCreations',{attrs:{"clients":_vm.clients}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }